import { Link, styled, TableCell, TableRow } from "@mui/material";
import { GeoJSON, Map } from "leaflet";
import { useTranslation } from "react-i18next";

import { deleteLayerStyle } from "config/geometryStyles";

import { Measure, MeasureConfLayer, MeasureConf } from "types/types";
import { resetPointLayerStyle } from "utils/GeomanUtils";

interface Props {
  index: number;
  mapRef: Map;
  basePolygon: GeoJSON;
  measure: Measure;
  measureConfigurations: MeasureConf[];
  layer: MeasureConfLayer;
  removeLayerFromMeasureConfig: (layerId: number) => void;
}

export function ActiveMeasureConfigPointItem(props: Props) {
  const { index, measure, layer, removeLayerFromMeasureConfig } = props;
  const { t } = useTranslation();

  function setDeleteStyles() {
    // @ts-ignore
    layer.geometryLayer.setStyle({ ...deleteLayerStyle, zIndex: 99999999 });
  }

  function resetStyles() {
    resetPointLayerStyle(layer.geometryLayer, measure);
  }

  function deleteMeasureConfig() {
    removeLayerFromMeasureConfig(layer.id);
    layer.geometryLayer.remove();
  }

  return (
    <StyledTableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell className="no-wrap">
        {t("label.measureWithNumber", {
          measure: measure.name,
          number: index + 1,
        })}
      </TableCell>
      <TableCell className="flex-cell">
        <Link
          className="align-right delete-button"
          onMouseOver={setDeleteStyles}
          onMouseLeave={resetStyles}
          onClick={deleteMeasureConfig}
        >
          {t("label.delete")}
        </Link>
      </TableCell>
    </StyledTableRow>
  );
}

const StyledTableRow = styled(TableRow)`
  .flex-cell {
    display: flex;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .no-wrap {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .MuiTableCell-root {
    padding: ${({ theme }) => theme.spacing(1)};
    border: unset;
  }
`;
